import { Component, OnInit } from '@angular/core';
import {DocumentService} from "../../services/document.service";
import {BusService} from "../../services/bus.service";
import {FactoryService} from "../../services/factory.service";
import {CollectionService} from "../../services/collection.service";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {JP} from "../../helpers/jp";
import {IWeightAttributes} from "../../interfaces/weight-attributes.definition";
import {inputUtils} from "../../helpers/input-utils";
import {CONDITION_TYPES_LIST} from "../../enums/e-conditions";
import {UI_TEXTS} from "../../enums/e-texts";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";


@Component({
  templateUrl: './weights.attributes-page.component.html'
})
export class WeightsAttributesPageComponent implements OnInit {
  CONDITION_TYPES_LIST = CONDITION_TYPES_LIST; //todo: фильтровать на лету уже используемые типы
  UI_TEXTS = UI_TEXTS;
  VAL_TYPES = VALUE_TYPE;
  E_ENDPOINTS = E_ENDPOINTS;

  private documentType: string = DOCUMENT_TYPES.WEIGHT;
  private documentId: string;

  public document: IWeightAttributes;

  get questBlueprints(): any[] {
    inputUtils.initializeArrayIfMissing(this.document, "/questConditionBlueprints");
    return JP.get(this.document, "/questConditionBlueprints");
  }


  constructor(private collectionService:CollectionService,
              private factoryService: FactoryService,
              private busService: BusService,
              private documentService: DocumentService) {
  }


  addNewBlueprint() {
    this.factoryService.pushNewBlueprint(this.questBlueprints);
  }



  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.document = <IWeightAttributes>e.document);

    this.loadDocumentIdThenDocumentItself();
  }


  onLoadClick():void {
    this.loadDocument();
  }


  private loadDocumentIdThenDocumentItself() {
    const params = paramsHelper.loader()
      .setEndpointApi()
      .setNavParams(0, 1)
      .setObjectType(this.documentType);

    this.collectionService.loadChunkAndAssertOne(params)
      .subscribe(document => {
        this.documentId = document._id;
        this.loadDocument();
      });
  }

  private loadDocument() {
    if (this.documentId) {
      this.documentService.load(E_ENDPOINTS.API, this.documentType, this.documentId);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/attributes/weights.attributes-page.component.ts